<template>
  <div class="container-fixed">
    <div class="container-fixed_footer">
      <div class="CFF_list">
        <div class="item">
          <div class="item_img">
            <img src="@/assets/image/Footer/footer_item1.png" alt="">
          </div>
          <div class="item_text">
            <div>找回包赔 玩腻换号</div>
            <div>不玩回收 找回包赔 玩腻换号</div>
          </div>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/image/Footer/footer_item2.png" alt="">
          </div>
          <div class="item_text">
            <div>官方交易 资金保障</div>
            <div>签署正规电子版合同 找回包赔</div>
          </div>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/image/Footer/footer_item3.png" alt="">
          </div>
          <div class="item_text">
            <div>9:30-00:30 专属客服</div>
            <div>专业客服团队为您服务</div>
          </div>
        </div>
        <div class="item">
          <div class="item_img">
            <img src="@/assets/image/Footer/footer_item4.png" alt="">
          </div>
          <div class="item_text">
            <div>游选账号 安全可靠</div>
            <div>承接所有游戏账号类型交易</div>
          </div>
        </div>
      </div>

    </div>
    <div class="footer">
      <div class="footer_inner">
        <router-link class="logo" :to="{path:'/'}">
          <img src="@/assets/logo/logo_horizontal_white.svg" alt="游选">
        </router-link>
        <div class="border"></div>
        <div class="box">
          <div class="linkList">
            <router-link :to="{path:'/'}" class="linkItem">首页</router-link>
            <router-link :to="{name:'TradeTip',query:{id:'116',parent_id:'83'}}" class="linkItem">服务协议</router-link>
            <router-link :to="{name:'TradeTip',query:{id:'108',parent_id:'83'}}" class="linkItem">业务介绍</router-link>
            <router-link :to="{name:'Legal',query:{id:'15',parent_id:'13'}}" class="linkItem">找回赔偿</router-link>
            <router-link :to="{name:'Legal',query:{id:'113',parent_id:'13'}}" class="linkItem">追回案例</router-link>
            <router-link :to="{name:'Legal',query:{id:'104',parent_id:'13'}}" class="linkItem">法务介绍</router-link>
            <router-link :to="{name:'About',query:{id:'7',parent_id:'18'}}" class="linkItem">公司介绍</router-link>
          </div>
          <div id="box">
            <div class="icp">
              <a v-if="data.icp" href="https://beian.miit.gov.cn/" target="_blank" class="user_center">{{ data.icp }}</a>
              <a class="police-record" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33070302100220">
                <img src="../assets/image/Footer/gonganbeian.png" alt="">
                <p>
                  浙公网安备 33070302100220号
                </p>
              </a>
              <a href="https://images.pxb7.com/zhizhao1.pdf" target="_blank" class="user_center cert-link">电子营业执照</a>
              <a href="https://images.pxb7.com/icp.jpg" target="_blank" class="user_center cert-link">浙B2-20210138</a>
            </div>
            <div class="copy">
              &copy;版权所有 游选游戏服务网 All Rights Reserved 抄袭必究
            </div>
          </div>
          <div class="img_ground">
            <a><img src="@/assets/image/Footer/shiming.png" alt=""></a>

            <a target="cyxyv" href="https://v.yunaq.com/certificate?domain=www.pxb7.com&from=label&code=90040">
              <img src="https://aqyzmedia.yunaq.com/labels/label_lg_90040.png" alt="">
            </a>
<!--          <a href="https://xinyong.yunaq.com/certificate?domain=www.pxb7.com&from=label&code=10010" target="_blank"><img-->
<!--            src="@/assets/image/Footer/quanwei.png"></a>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {apiSystem} from "@/request/API";

export default {
  name: '',
  props: {},
  components: {},
  data() {
    return {
      data: this.$store.state.systemInfo
    }
  },
  methods: {
  },
  created() {
    setTimeout(()=>{
      this.data = this.$store.state.systemInfo
    },500)
  },
  watch: {},
  computed: {}
}
</script>

<style lang='less' scoped>
.container-fixed {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  padding: 18px 0 0;

  .container-fixed_footer {
    width: 100vw;
    background: var(--bg-card, #FFFFFF);
    margin: 0 0 10px;

    .CFF_list {
      width: 1200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;

      .item {
        height: 90px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .item_img {
          img {
            opacity: 1;
          }
        }

        .item_text {
          margin: 0 0 0 9.5px;

          div:first-of-type {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            line-height: 22px;
            color: var(--text-secondary, #5A5F6B);
          }

          div:last-of-type {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Light;
            font-weight: 300;
            line-height: 20px;
            color: var(--text-muted, #9AA0AC);
            white-space: nowrap;
          }
        }
      }
    }
  }

  .footer {
    width: 100%;
    min-height: 240px;
    background: var(--bg-stage, #0E1116);
    border-top: 1px solid #1f242c;
    display: flex;
    align-items: center;
    justify-content: center;

    .footer_inner {
      width: 1200px;
      min-height: 180px;
      display: flex;
      align-items: center;
    }

    .logo {
      width: 246px;
      height: 84px;
      flex: 0 0 246px;
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        width: 246px;
        height: 84px;
        display: block;
        object-fit: contain;
      }
    }

    .border {
      flex: 1;
      min-width: 64px;
      height: 144px;
      margin: 0 64px;
      position: relative;

      &:before {
        content: '';
        width: 1px;
        height: 144px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        background: linear-gradient(180deg, rgba(42, 47, 56, 0), #2a2f38 18%, #2a2f38 82%, rgba(42, 47, 56, 0));
      }
    }

    .box {
      width: max-content;
      max-width: 100%;
      min-width: 0;
      min-height: 152px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .linkList {
        display: flex;
        flex-direction: row;
        align-items: center;

        .linkItem {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          line-height: 22px;
          color: #aeb4be;
          padding: 0 28px;
          border-right: 1px solid #2a2f38;
          text-align: center;
          white-space: nowrap;
          transition: color 0.2s ease;
        }

        .linkItem:hover {
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--primary, #FF5A1F);
        }

        .linkItem:first-of-type {
          padding-left: 0;
        }

        .linkItem:last-of-type {
          padding-left: 20px;
          padding-right: 0;
          border-right: none;
        }
      }
      #box{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Light;
        font-weight: 300;
        line-height: 20px;
        color: #5a5f6b;
        .icp{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          min-height: 20px;
          margin: 0 0 12px;
          gap: 10px 28px;
          a{
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Light;
            font-weight: 300;
            color: #aeb4be;
            transition: color 0.2s ease;
          }
          a:hover{
            color: var(--primary, #FF5A1F);
          }
          .police-record {
            height: 20px;
            display: inline-flex;
            align-items: center;
            text-decoration: none;

            img {
              width: 20px;
              height: 20px;
              display: block;
            }

            p {
              height: 20px;
              line-height: 20px;
              margin: 0 0 0 5px;
              color: #aeb4be;
            }
          }

          .cert-link {
            white-space: nowrap;
          }
        }

        .copy {
          color: #5a5f6b;
        }
      }
      .img_ground{
        height: 45px;
        display: flex;
        align-items: center;
        gap: 16px;
        a{
          width: 133px;
          height: 45px;
          display: block;
          img{
            width: 133px;
            height: 45px;
            display: block;
            object-fit: contain;
          }
        }
        a:first-of-type{
          margin: 0;
        }
      }

    }
  }
}

</style>
